module.exports = __webpack_public_path__ + "static/media/portisIcon.35926b13.png";